import UIPage from './ui-page.js';

export default UIPage;
